import { Injectable } from '@angular/core';
import environment from '../../environment';
import {ApiService} from './api.service';
@Injectable()
export class FavouritesService {
  constructor(protected Api: ApiService) {}

  public async editUserListingFavourite(listingId: string, favouriteStatus): Promise<any> {
    return this.Api.post(
      `${environment.settings.registeredAwsUrl}/favourites/${listingId}?favourite=${favouriteStatus}`,
      {}
    );
  }

  public async getUserListingFavourites(): Promise<any> {
    return this.Api.get(`${environment.settings.registeredAwsUrl}/favourites`).then((data) => {
      return data;
    });
  }
}
